import { getLangKey, getStoredLangCode } from "../../utils/language";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { NewsFeed, post, Profile, people } from "../../config/imagesLink";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import PersonalPost from "./PersonalPost";
import Followers from "./Followers";
import Following from "./Following";
import Likes from "./Likes";
import Photos from "./Photos";
import Videos from "./Videos";
import Saved from "./Saved";
import About from "./About";
import axios from "../../API/axios";
import { getShortMutualUserInfo } from "../../Services/apiService";
import toast from "react-hot-toast";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import Select from "react-select";
import { userAuthImage } from "../../config/imagesLink";
import "cropperjs/dist/cropper.css";
import "react-easy-crop/react-easy-crop.css";
import Cropper from "react-easy-crop";

// import Cropper from "react-cropper";
// import "cropperjs/dist/cropper.css";
import Mutuals from "./Mutuals";
import Follows from "./Follows";
import { ShimmerThumbnail } from "react-shimmer-effects";
import getCroppedImg from "./cropImage";
import { dataURLtoFile } from "./dataUrlToFile";
import ReactCropperComp from "./ReactCropperComp";
import { Button } from "react-bootstrap";
import ImageCropDialog from "./ImageCropDialog";
import ProfileBackground from "./ProfileBackground";
import FollowingTab from "./FollowingTab";
import { ProfilePageSkeleton } from "@skeleton";
import InfoSharpIcon from "@mui/icons-material/InfoSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import PersonAddAlt1SharpIcon from "@mui/icons-material/PersonAddAlt1Sharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import InsightsSharpIcon from "@mui/icons-material/InsightsSharp";
import QrCode2SharpIcon from "@mui/icons-material/QrCode2Sharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import BarChartSharpIcon from "@mui/icons-material/BarChartSharp";
import ArticleSharpIcon from "@mui/icons-material/ArticleSharp";
import FavoriteSharpIcon from "@mui/icons-material/FavoriteSharp";
import ChatBubbleSharpIcon from "@mui/icons-material/ChatBubbleSharp";
import ShareSharpIcon from "@mui/icons-material/ShareSharp";
import { Dropdown } from "react-bootstrap";

import { Helmet } from "react-helmet";
import Activities from "./Activities";
import Medias from "./Media";
import useNewsFeedStore from "../NewsFeed/useNewsFeedStore";
import { useTranslation } from "react-i18next";
import HiddenPost from "./HiddenPost";
import useWindowSize from "../useWindowSize";
import Connection from "./Connection";
import ModalForGuest from "../ModalForGuest";
import GoogleAdUnit from "../../components/GoogleAdUnit";
// import Connection from "./Connection";

const profileAboutRequestCache = new Map();
const profileAboutDataCache = new Map();
const profileAboutLastFetchMeta = { key: null, time: 0 };
const PROFILE_ABOUT_REMOUNT_WINDOW_MS = 800;

const getProfileAboutCacheKey = (uid, language) =>
  `${uid || ""}:${language || ""}`;

const PROFILE_TAB_MAP = {
  about: 1,
  post: 2,
  follower: 3,
  followers: 3,
  following: 4,
  saved: 7,
  hiddenpost: 8,
  mutualconnections: 9,
  mutualconnection: 9,
  activities: 11,
  media: 12,
};

const getProfileTabIndex = (routeTab) => {
  const tabKey = (routeTab || "").toLowerCase();
  return PROFILE_TAB_MAP[tabKey] || 1;
};

const PROFILE_TAB_ROUTES = {
  1: "About",
  2: "Post",
  3: "Follower",
  4: "Following",
  7: "Saved",
  8: "HiddenPost",
  9: "MutualConnections",
  11: "Activities",
  12: "Media",
};

const DashboardStatCard = ({ label, value, loading, tone = "posts" }) => (
  <div className="col-6">
    <div className={`dashboard-card dashboard-card--${tone}`}>
      <p className="dashboard-card-label">{label}</p>
      {loading ? (
        <span className="dashboard-card-skeleton" aria-hidden="true" />
      ) : (
        <p className="dashboard-card-value">
          {Number(value || 0).toLocaleString()}
        </p>
      )}
    </div>
  </div>
);

const DashboardSection = ({ icon, title, tone, children }) => (
  <section className={`dashboard-section dashboard-section--${tone}`}>
    <div className="dashboard-section-title">
      <span className={`dashboard-section-icon dashboard-section-icon--${tone}`}>
        {icon}
      </span>
      <h6>{title}</h6>
    </div>
    <div className="row g-2">{children}</div>
  </section>
);

const DashboardSideStat = ({ icon, label, value, loading }) => (
  <div className="dashboard-side-stat">
    <span className="dashboard-side-stat-icon">{icon}</span>
    <div className="dashboard-side-stat-copy">
      <p className="dashboard-side-stat-label">{label}</p>
      {loading ? (
        <span className="dashboard-card-skeleton dashboard-card-skeleton--sm" aria-hidden="true" />
      ) : (
        <p className="dashboard-side-stat-value">
          {Number(value || 0).toLocaleString()}
        </p>
      )}
    </div>
  </div>
);

const PersonalProfile = ({ postList, setProgress, setIsVideoProcessing }) => {
  const { t } = useTranslation();
  const guestModeData = localStorage.getItem("guestMode");
  const sessionId = localStorage.getItem("sessionId");
  const ProfilePercent = localStorage.getItem("ProfilePercentage"); 
  const language = getStoredLangCode();
  const { uid , tab} = useParams();
  const userUid = localStorage.getItem("userUid");
  const [userData, setUserData] = useState([]);
  console.log("UserData===>", userData)
  const [userStat, setUserStat] = useState([]);
  console.log("userStat", userStat);
  //   State for Toasters
    const [showTabDropdown, setShowTabDropdown] = useState(false);
  const tabDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tabDropdownRef.current && !tabDropdownRef.current.contains(event.target)) {
        setShowTabDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [openBgModal, setOpenBgModal] = useState(false);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const navigate = useNavigate();

  const [image, setImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedImage, setCroppedImage] = useState(null);

  const cropperRef = useRef(null);
  const cropperRef1 = useRef(null);
  const [loading, setLoading] = useState(false);


  const handleBgOpen = (event) => {
    event.stopPropagation();
    setOpenBgModal(true);
  };
  const [isloading, setIsloading] = useState(true);
  const [errorImage, setErrorImage] = useState(false);

  const getUserProfile = () => {
    const data = {
      deviceType: "Web",
      userUid: uid,
      langKey: language,
    };
    return axios
      .post(`UserProfile/GetUserProfile`, data)
      .then((response) => {
        const res = response.data.responseData;
        setUserData(res);
        window.dispatchEvent(new Event("profileScoreRefresh"));
        return response;
      })
      .catch((error) => {
        setErrorImage(true);
        console.log(error);
        throw error;
      });
  };

  const getUserProfileAbout = () => {
    const cacheKey = getProfileAboutCacheKey(uid, language);

    const inFlightRequest = profileAboutRequestCache.get(cacheKey);
    if (inFlightRequest) {
      inFlightRequest
        .then((response) => {
          if (response.status === 204 || response.status === 400) {
            setErrorImage(true);
          } else {
            setUserData(response.data.responseData);
          }
        })
        .catch(() => {
          setErrorImage(true);
        })
        .finally(() => {
          setIsloading(false);
        });
      return inFlightRequest;
    }

    const isRapidRemount =
      profileAboutLastFetchMeta.key === cacheKey &&
      Date.now() - profileAboutLastFetchMeta.time <
        PROFILE_ABOUT_REMOUNT_WINDOW_MS;

    if (isRapidRemount && profileAboutDataCache.has(cacheKey)) {
      setIsloading(false);
      setUserData(profileAboutDataCache.get(cacheKey));
      return Promise.resolve();
    }

    if (!isRapidRemount) {
      setIsloading(true);
      setErrorImage(false);
      setUserData(null);
    }

    profileAboutLastFetchMeta.key = cacheKey;
    profileAboutLastFetchMeta.time = Date.now();

    const data = {
      deviceType: "Web",
      userUid: uid,
      langKey: language,
    };

    const request = axios
      .post(`UserProfile/GetUserProfile`, data)
      .then((response) => {
        const currentScroll = window.scrollY;
        if (response.status === 204 || response.status === 400) {
          setErrorImage(true);
        } else {
          const res = response.data.responseData;
          profileAboutDataCache.set(cacheKey, res);
          setUserData(res);
          if (!isRapidRemount) {
            setTimeout(() => {
              window.scrollTo({ top: currentScroll });
            }, 50);
          }
        }
        return response;
      })
      .catch((error) => {
        setErrorImage(true);
        console.log(error);
        throw error;
      })
      .finally(() => {
        setIsloading(false);
        profileAboutRequestCache.delete(cacheKey);
      });

    profileAboutRequestCache.set(cacheKey, request);
    return request;
  };

  useEffect(() => {
    getUserProfileAbout();
  }, [uid]);

  //************************User Profile Get End  ************************//

  //************************User Profile Stats Start  ************************//
  const [showDeletePost, setShowDeletePost] = useState(false);
  const getUserProfileStat = () => {
    const data = {
      deviceType: "Web",
      userUid: uid,
    };
    return axios
      .post(`UserProfile/GetUserProfileStats`, data)
      .then((response) => {
        if (response.status === 204 || response.status === 400) {
          setErrorImage(true);
        } else {
          const res = response.data.responseData;
          setUserStat(res);
        }
        return response;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  };
  useEffect(() => {
    getUserProfileStat();
  }, [uid, showDeletePost]);

  //************************User Profile Stats End  ************************//

  //************************Followed User  ************************//
  const [isfollowed, setIsfollowed] = useState(false);
  const [isBlockedByYou, setIsBlockedByYou] = useState(false);

  useEffect(() => {
    if (userData?.profileInfo) {
      setIsfollowed(userData.profileInfo.isFollowedByYou);
      setIsBlockedByYou(userData.profileInfo.isBlockedByYou === true);
    }
  }, [userData]);

  const FollowedUser = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      langKey: getLangKey(language),
      
    };
    try {
      await axios.post("UserFollow/FollowUser", data).then((resData) => {
        // console.log("resData", resData);
        // toast.success(resData.data.message);
        // getUserProfileList();
        setIsfollowed(true);
        setToastMessage(resData.data.message);
        setShowToast(true);
        getUserProfile();
        // CheckFollowedUser();
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  console.log("isfollowed", isfollowed);
  //************************Followed User  ************************//

  const [showModal, setShowModal] = useState(false);
  const [ownerDash, setOwnerDash] = useState({
    postsAll: 0,
    postsMonth: 0,
    likedByYou: 0,
    likedToYou: 0,
    commentedByYou: 0,
    commentedToYou: 0,
    sharedByYou: 0,
    sharedToYou: 0,
    postImpressions: 0,
    profileViews: 0,
  });
  const [ownerDashLoading, setOwnerDashLoading] = useState(false);

  const openModal = async () => {
    setShowModal(true);
    if (!sessionId || guestModeData === "true") return;
    setOwnerDashLoading(true);
    try {
      const res = await axios.get(
        `Impression/OwnerDashboard?DeviceType=Web&LangKey=${getLangKey(language)}`
      );
      const data = res?.data?.responseData || res?.data?.ResponseData;
      if (data && typeof data === "object") {
        setOwnerDash((prev) => ({
          ...prev,
          postsAll: data.postsAll ?? data.PostsAll ?? 0,
          postsMonth: data.postsMonth ?? data.PostsMonth ?? 0,
          likedByYou: data.likedByYou ?? data.LikedByYou ?? 0,
          likedToYou: data.likedToYou ?? data.LikedToYou ?? 0,
          commentedByYou: data.commentedByYou ?? data.CommentedByYou ?? 0,
          commentedToYou: data.commentedToYou ?? data.CommentedToYou ?? 0,
          sharedByYou: data.sharedByYou ?? data.SharedByYou ?? 0,
          sharedToYou: data.sharedToYou ?? data.SharedToYou ?? 0,
          postImpressions: data.postImpressions ?? data.PostImpressions ?? 0,
          profileViews: data.profileViews ?? data.ProfileViews ?? 0,
        }));
      }
    } catch (e) {
      // keep zeros — dashboard is additive
    } finally {
      setOwnerDashLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  //************************ Website   ************************//

  const [selectedOption, setSelectedOption] = useState(null);
  const [workOption, setWorkOptionDDL] = useState([])

  const getGoToWork = () => {
    axios
      .get(`Master/GetOpenToDDL?LangKey=${language}`)
      .then((response) => {
        console.log("Goto Work DDL", response.data.responseData);
        const res = response.data.responseData;
        // const data = res.map((item) => ({
        //   value: item.jbSlryTypId,
        //   label: item.name,
        // }));
        setWorkOptionDDL(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getGoToWork();
  }, []);

  useEffect(() => {
  if (workOption.length > 0 && !selectedOption) {
    setSelectedOption(workOption[0]);
  }
}, [workOption]);
  
  const handleSelection = (option) => {
    console.log("Check Button Id===>", option)
    setSelectedOption(option); // set full object { id, name onChange={(e) => {
    setOptionsValue(option.id);
    setOptionsLabel(option.name);

  };

  const options = [
    { value: "0", label: "None" },
    { value: "1", label: "ToWork" },
    { value: "2", label: "ToHire" },
    { value: "3", label: "Freelance" },
  ];

  useEffect(() => {
    if (userData?.openInfo?.type && workOption.length > 0) {
      const matched = workOption.find((opt) => opt.value === userData.openInfo.type);
      if (matched) {
        setSelectedOption(matched);
        setOptionsLabel(matched.value);
        setOptionsValue(matched.id);
      }
    }
  }, [userData, workOption]);

  // console.log("Selected Option12345====>", selectedOption)
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    // setOptionsValue(selectedOption.id);
    // setOptionsLabel(selectedOption.name);
  };

  const [optionsValue, setOptionsValue] = useState();
  const [optionsLabel, setOptionsLabel] = useState("");
  // console.log(optionsValue, optionsLabel);
  const [openToModal, setOpenToModal] = useState(false);
  const [mutualCounts, setMutualCounts] = useState(0);

  const handleopenToModal = () => {
    setOpenToModal(false);
  };

  const OpenTo = async () => {
    try {
      if (selectedOption.value !== null && selectedOption.value !== "") {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("Type", selectedOption.value);
        formData.append("VisibilityType", selectedOption.id);
        formData.append("LangKey", language);
        const res = await axios.post("UserAccount/SetOpenTo", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        setToastMessage(res.data.message);
        setShowToast(true);
        setOpenToModal(false);
        getUserProfile();
      } else {
        toast.error("Please Select!");
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error?.response?.data?.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error?.response?.data?.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************ Website  End ************************//

  //************************ Connect User Start  ************************//

  // const ConnectUser = async (id) => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     userUID: uid,
  //   };
  //   try {
  //     await axios
  //       .post("Connection/SendConnectionRequest", data)
  //       .then((resData) => {
  //         // console.log("resData", resData.data.message);
  //         // toast.success(resData.data.message);
  //         setToastMessage(resData.data.message);
  //         setShowToast(true);
  //         // CheckFollowedUser();
  //       });
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       setWarningToastMessage(error.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.message);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };

  //************************ Connect User  End  ************************//

  // //************************Check Connect User Start  ************************//

  const [showCancelRequestModal, setShowCancelRequestModal] = useState(false);

  const [connectionCheck, setConnectionCheck] = useState("");
  
  const [disconectCheck, setDisconectCheck] = useState(false);
  
  const [connectionId, setConnectionId] = useState("");

  // Update disconectCheck when userData is loaded
  useEffect(() => {
    if (userData?.profileInfo?.isConnectedByYou !== undefined) {
      setDisconectCheck(userData?.profileInfo?.isConnectedByYou);
    }
  }, [userData?.profileInfo?.isConnectedByYou]);

  console.log("connectionCheck", disconectCheck);
  // api removed from backend
  const CheckConnectUser = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
    };
    try {
      await axios.post("Connection/CheckConnection", data).then((resData) => {
        // console.log("checkFollowedUser", resData.data);
          setConnectionCheck(resData.data.responseData.value);
          setConnectionId(resData.data.responseData.id); 
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userData?.profileInfo?.isOwn === false && userData?.profileInfo?.isConnectedByYou === null) {
      CheckConnectUser(); 
    }
  }, [userData?.profileInfo?.isConnectedByYou]);



  const handleConnectionSuccess = (resData, msgType) => {
    if (msgType === "success") {
      setToastMessage(resData?.data?.message);
      setShowToast(true);
      CheckConnectUser();
    }
    if (msgType === "error") {
      setErrorToastMessage(resData.data.message);
      setShowErrorToast(true);
    }
  };
  const handleConnectionRejected = () => {
    setShowCancelRequestModal(true);
  };
  const cancelRequestClose = () => {
    setShowCancelRequestModal(false);
  };
  const CancelRequest = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
    };
    console.log(data);
    try {
      await axios
        .post("Connection/CancelConnectionRequest", data)
        .then((resData) => {
          console.log(resData);
          setShowCancelRequestModal(false);
          setToastMessage(resData.data.message);
          setShowToast(true);
          CheckConnectUser();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
        setShowCancelRequestModal(false);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
        setShowCancelRequestModal(false);
      }
    }
  };

  // //************************ Connect User  End  ************************//

  
  const [activeTab, setActiveTab] = useState(() => getProfileTabIndex(tab));

  const goToProfileTab = (tabIndex) => {
    setActiveTab(tabIndex);
    const tabPath = PROFILE_TAB_ROUTES[tabIndex];
    if (tabPath && uid) {
      navigate(`/User/${uid}/${tabPath}`);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 1:
        return (
          <About
            userData={userData}
            uid={uid}
            getUserProfile={getUserProfile}
            isloading={isloading}
            connectionCheck={connectionCheck}
            setConnectionCheck={setConnectionCheck}
            connectionId={connectionId}
            CheckConnectUser={CheckConnectUser} 
            setDisconectCheck={setDisconectCheck}
            disconectCheck={disconectCheck}
            isfollowed={isfollowed}
            setIsfollowed={setIsfollowed}
            checkblock={isBlockedByYou}
            setCheckblock={setIsBlockedByYou}
          />
        );
      case 2:
        return (
          <PersonalPost
            setIsVideoProcessing={setIsVideoProcessing}
            setProgress={setProgress}
            uid={uid}
            getUserProfileStat={getUserProfileStat}
            setShowDeletePost={setShowDeletePost}
            showDeletePost={showDeletePost}
            setUserStat={setUserStat}
            userStat={userStat}
          />
        );
      case 3:
        return <Followers uid={uid} getUserProfileStat={getUserProfileStat} />;
      case 4:
        return (
          <FollowingTab
            uid={uid}
            getUserProfileStat={getUserProfileStat}
            userData={userData}
            getUserProfile={getUserProfile}
          />
        );
      case 5:
        return <Likes />;
      case 6:
        return <Photos />;
      case 7:
       return <Saved getUserProfileStat={getUserProfileStat}
          setShowDeletePost={setShowDeletePost}
          showDeletePost={showDeletePost} />;
       
      case 8:
          return  <HiddenPost getUserProfileStat={getUserProfileStat}
          setShowDeletePost={setShowDeletePost}
          showDeletePost={showDeletePost} />
       
      case 9:
        return (
          <Mutuals
            uid={uid}
            getUserProfileStat={getUserProfileStat}
            setMutualCounts={setMutualCounts}
            mutualCounts={mutualCounts}
            fetchShortMutualList={fetchShortMutualList}
          />
        );
      case 10:
        return <Follows uid={uid} getUserProfileStat={getUserProfileStat} />;
      case 11:
        return <Activities uid={uid} getUserProfileStat={getUserProfileStat} />;
      case 12:
        return <Medias uid={uid} getUserProfileStat={getUserProfileStat} userData={userData} />;
      default:
        return null;
    }
  };

  const handleOpenBgCloseModal = () => {
    setOpenBgModal(false);
  };

  const handleOpenProfileCloseModal = () => {
    setOpenProfileModal(false);
  };
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    scrollToTop();
  }, [uid]);
  // const handleScroll = () => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // };

  // useEffect(() => {
  //   handleScroll();
  // }, []);

  console.log("selected image", image);
  const [shortMutualList, setShortMutualList] = useState([]);
  const fetchShortMutualList = async () => {
    try {
      const responseData = await getShortMutualUserInfo(uid);
      console.log("response?.data?.responseData", responseData);

      setShortMutualList(responseData);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // setIsError(true);
      } else {
        console.log(error);
      }
    }
  };
  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      fetchShortMutualList();
    }
  }, [uid]);

  console.log("shortMutualList", shortMutualList);

  useEffect(() => {
    if (showDeletePost) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showDeletePost]);

   
  //************************ Profile Picture ************************//
  const [selectedProfileImage, setSelectedProfileImage] = useState(null);
  const [profileSourceImage, setProfileSourceImage] = useState(null);
  const [profileCropImage, setProfileCropImage] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [profileModal, setProfileModal] = useState(false);

  const fileInputRefProfile = useRef(null);

  const handleProfileClick = () => {
    fileInputRefProfile.current.click();
  };

  const handleProfileImageChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      setProfileImage(selectedFile);
      setSelectedProfileImage(dataUrl);
      setProfileSourceImage(dataUrl);
      setProfileCropImage(dataUrl); // open cropper with full image
      try { sessionStorage.setItem("tempProfileImage", dataUrl); } catch (e) {}
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setRotation(0);
      setShowProfileCropper(true);
      setProfileModal(false);
    };
    reader.readAsDataURL(selectedFile);
    event.target.value = "";
  };

  const handleProfileModalClose = () => {
    setProfileModal(false);
  };

  const ProfileImageUpload = async () => {
    localStorage.removeItem("user-profilPic");
    localStorage.removeItem("profilPic");
    try {
      if (profileImage !== null) {
        setLoading(true);
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("ProfilPic", profileImage);
        formData.append("Language",getLangKey(language),);
        const res = await axios.post("/UserAccount/SetProfilePic", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log("response: ", res.data.responseData);
        setToastMessage(res.data.message);
        setShowToast(true);
        setProfileModal(false);
        getUserProfile();
        // window.localStorage.setItem("user-profilPic", res.data.responseData);
        // window.localStorage.setItem("profilPic", res.data.responseData);
        // Store in localStorage
        const newImageUrl = res.data.responseData;
        window.localStorage.setItem("user-profilPic", newImageUrl);
        window.localStorage.setItem("profilPic", newImageUrl);

        // Dispatch a custom event
        window.dispatchEvent(
          new CustomEvent("profilePicUpdated", {
            detail: newImageUrl,
          })
        );
        try { sessionStorage.removeItem("tempProfileImage"); } catch (e) {}
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    } finally {
      setLoading(false);
    }
  };
  //************************ Profile Picture End ************************//

  //************************ Background Image   ************************//
  const [bgSelectedImage, setBgSelectedImage] = useState(null);
  const [bgSourceImage, setBgSourceImage] = useState(null);
  const [bgCropImage, setBgCropImage] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState(null);
  // cropping UI state
  const [showBgCropper, setShowBgCropper] = useState(false);
  const [bgCroppedAreaPixels, setBgCroppedAreaPixels] = useState(null);
  // console.log(backgroundImage);
  const [bgModal, setBgModal] = useState(false);
  const handleBgModal = () => {
    setBgModal(false);
  };
  const fileInputRefBg = useRef(null);
  const handleBgClick = () => {
    fileInputRefBg.current.click();
  };
  const handleBgImageChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      setBackgroundImage(selectedFile);
      setBgSelectedImage(dataUrl);
      setBgSourceImage(dataUrl);
      setBgCropImage(dataUrl); // open cropper with full image
      // persist temporary selection so other components/modals can read it
      try {
        sessionStorage.setItem("tempBgImage", dataUrl);
      } catch (e) {}
      // reset crop UI
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setRotation(0);
      setShowBgCropper(true);
    };
    reader.readAsDataURL(selectedFile);
    // allow selecting the same file again later
    event.target.value = "";
  };

  // initialize from any temporary selection made in other modals/components
  useEffect(() => {
    try {
      const tmpProfile = sessionStorage.getItem("tempProfileImage");
      if (tmpProfile) setSelectedProfileImage(tmpProfile);
      const tmpBg = sessionStorage.getItem("tempBgImage");
      if (tmpBg) {
        setBgSelectedImage(tmpBg);
        setBgSourceImage(tmpBg);
        setBgCropImage(tmpBg);
      }
    } catch (e) {}
  }, []);

  const onBgCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setBgCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const saveBgCroppedImage = async () => {
    try {
      const croppedImageUrl = await getCroppedImg(
        bgSelectedImage,
        bgCroppedAreaPixels,
        rotation
      );
      // convert object URL to File
      const response = await fetch(croppedImageUrl);
      const blob = await response.blob();
      const file = new File([blob], "cropped-bg.jpg", {
        type: "image/jpeg",
      });
      setBackgroundImage(file);
      setBgSelectedImage(croppedImageUrl);
      try {
        sessionStorage.setItem("tempBgImage", croppedImageUrl);
      } catch (e) {}
      setShowBgCropper(false);
      setBgModal(true);
    } catch (e) {
      console.error("Error cropping image:", e);
      setShowBgCropper(false);
    }
  };

  const cancelBgCropping = () => {
    // close cropper and show preview (don't clear selection)
    setShowBgCropper(false);
    setBgModal(true);
  };

  const BgImageUpload = async () => {
    try {
      if (backgroundImage !== null) {
        setLoading(true);
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("BackGroundImage", backgroundImage);
        formData.append("Language",getLangKey(language),);
        const res = await axios.post(
          "/UserAccount/SetBackgroundImage",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setBgModal(false);
        getUserProfile();
        // userConfig();
        try { sessionStorage.removeItem("tempBgImage"); } catch (e) {}
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    } finally {
      setLoading(false);
    }

  };

    // cropping UI for profile picture
    const [showProfileCropper, setShowProfileCropper] = useState(false);
    const [profileCroppedAreaPixels, setProfileCroppedAreaPixels] = useState(null);

    const onProfileCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
      setProfileCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const saveProfileCroppedImage = async () => {
      try {
        const sourceImage = profileCropImage || selectedProfileImage;
        const croppedImageUrl = await getCroppedImg(
          sourceImage,
          profileCroppedAreaPixels,
          rotation
        );
        // convert object URL to File
        const response = await fetch(croppedImageUrl);
        const blob = await response.blob();
        const file = new File([blob], "cropped-profile.jpg", {
          type: "image/jpeg",
        });
        setProfileImage(file);
        setSelectedProfileImage(croppedImageUrl);
        try {
          sessionStorage.setItem("tempProfileImage", croppedImageUrl);
        } catch (e) {}
        // clear the intermediate crop source so re-opening uses correct state
        setProfileCropImage(null);
        setShowProfileCropper(false);
        setProfileModal(true);
      } catch (e) {
        console.error("Error cropping profile image:", e);
        setShowProfileCropper(false);
      }
    };

    const cancelProfileCropping = () => {
      // close cropper and show preview (don't clear selection)
      setShowProfileCropper(false);
      setProfileModal(true);
    };

    const deleteProfileSelection = () => {
      setSelectedProfileImage(null);
      setProfileImage(null);
      setProfileModal(false);
      try { sessionStorage.removeItem("tempProfileImage"); } catch (e) {}
    };

  //************************ Background Image End  ************************//

  useEffect(() => {
    if (showModal || profileModal || openProfileModal || openBgModal || showBgCropper || showProfileCropper) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showModal, profileModal, openProfileModal, openBgModal, showBgCropper, showProfileCropper]);

  const [alert, setAlert] = useState(false);
  const [isLoadingalert, setIsLoadingalert] = useState(true); // Add loading state

 
  const normalizedUserPer = Array.isArray(ProfilePercent)
    ? ProfilePercent.length === 0
      ? 0
      : Number(ProfilePercent[0])
    : Number(ProfilePercent);
  // Condition to show the alert
  const shouldShowAlert =
    !isLoadingalert ||
    normalizedUserPer <= 59 &&
    alert === false &&
    guestModeData === null;
  console.log("userdata", userData);

  const size = useWindowSize();
  const isMobileViewport = size.width <= 768;
  const [showToolbar, setShowToolbar] = useState(false);

  useEffect(() => {
    if (isMobileViewport) {
      setShowToolbar(false);
      return undefined;
    }

    const handleScroll = () => {
      setShowToolbar(window.scrollY > 300);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobileViewport]);
   // -------------------------------------------------------------------------
    const { setIsNewsPageLoaded } = useNewsFeedStore();

    useEffect(() => {
        setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

        return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
    }, [setIsNewsPageLoaded]);

    // -------------------------------------------------------------------------


  useEffect(() => {
    setActiveTab(getProfileTabIndex(tab));
  }, [tab]);

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  const handleBannerImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.background;
  };

  const profilePicSrc =
    userData?.profileInfo?.profilPic || people.DefaultProfile;

  const bannerImageSrc =
    bgSelectedImage ||
    userData?.profileInfo?.backGroundImage ||
    people.background;


  const [jobModal, setJobModal] = useState(false);
  const closeModalData = () => {
    setJobModal(false);
  };
  
  return (
    <>
      <Helmet>
        <title>
          {`${userData?.profileInfo?.firstName}`} Profile | Welinkjobs
        </title>
        <meta name="description" content={`${userData?.profileInfo?.about}`} />
        {/* <meta name="keywords" content="react, meta tags, seo" /> */}
        <meta name="keywords" content="newsfeed, updates, latest news" />
        {/* <meta name="author" content="Your Name" /> */}
        <meta
          property="og:title"
          content={`${userData?.profileInfo?.firstName} Profile | Welinkjobs`}
        />
        <meta
          property="og:description"
          content={`${userData?.profileInfo?.about}`}
        />
        {/* <meta property="og:image" content="https://example.com/image.jpg" /> */}
        <meta property="og:url" content="https://welinkjobs.com/NewsFeeds" />
      </Helmet>

      {userData?.profileInfo?.isOwn === true
        ? shouldShowAlert && (
          <div className="p-3 closeAccount m-0 mb-3 mt-2">
            <div className="d-flex mb-3 align-items-center">
              <InfoSharpIcon />
              <span className="cardHeader ms-1">{t("Newsfeed.Announcement")}</span>
              <span className="ms-auto">
                <CloseSharpIcon
                  style={{ width: "20px" }}
                  className="pointer"
                  onClick={() => setAlert(true)} // Dismiss the alert
                />
              </span>
            </div>
            <div>
              <span>
                {t("Newsfeed.Accounce")}
              </span>
              <Link to={`/User/${userUid}`} className="border-bottom f-600 warn-resume">
                                               
                                                {/* {t("Newsfeed.Manage Profile")} */}
                                          </Link>
            </div>
             
          </div>
        )
        : ""}

      {isloading || !userData?.profileInfo ? (
        <ProfilePageSkeleton className="mt-2" />
      ) : errorImage ? (
            <>
             <div className="mt-5 text-center"> 
               <img src={post.errorSmall} alt="404 Not Found" width={250} className="mt-3" />
            </div>
            </>
          ) 
          : (
            <>
              <div className="ProfileInner new-ProfileInner">
                  <div className="card profileCard desktopView new-profileCard mt-3">
                    <div className="Profilebackground">
                      {userData && userData?.openInfo?.type === "ToWork" ? (
                        <div className="Profilebadge ProfilebadgeWillingToWork"   
                        style={{
                          direction: language === 'ar' ? 'rtl' : 'ltr',
                          textAlign: language === 'ar' ? 'right' : 'left',
                        }}>
                          <h6>#{t("User Profile.WillingToWork")}</h6>
                          
                          {userData?.profileInfo?.isOwn && (
                            <EditSharpIcon
                              className="material-symbols-sharp cursor-pointer badge-edit-icon"
                              onClick={() => setOpenToModal(true)}
                            />
                          )}
                        </div>
                      ) : userData?.openInfo?.type === "ToHire" ? (
                        <div className="Profilebadge ProfilebadgeWeAreHiring"   
                        style={{
                            direction: language === 'ar' ? 'rtl' : 'ltr',
                            textAlign: language === 'ar' ? 'right' : 'left',
                          }}>
                          <h6>#{t("User Profile.WeAreHiring")} </h6>
                          {userData?.profileInfo?.isOwn && (
                            <EditSharpIcon className="material-symbols-sharp cursor-pointer badge-edit-icon" onClick={() => {
                              setOpenToModal(true);
                            }} />

                          )}
                        </div>
                      ) : userData?.openInfo?.type === "Freelance" ? (
                        <div className="Profilebadge ProfilebadgeFreelancing"
                          style={{
                            direction: language === 'ar' ? 'rtl' : 'ltr',
                            textAlign: language === 'ar' ? 'right' : 'left',
                          }}>
                          <h6>#{t("User Profile.Freelancing")}</h6>
                          {userData?.profileInfo?.isOwn && (
                            <EditSharpIcon className="material-symbols-sharp cursor-pointer badge-edit-icon" onClick={() => {
                              setOpenToModal(true);
                            }} />
                          )}
                        </div>
                      ) : null}
 
                        <div
                          className="background-overlay"
                          onClick={(event) => setOpenBgModal(true)}
                        >
                          <img
                            src={bannerImageSrc}
                            alt=""
                            height={200}
                            onError={handleBannerImageError}
                          />
                          {userUid === uid && (
                            <>
                              <label
                                htmlFor="fileInput"
                                className="backgroundimg-edit"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  // setBgModal(true);
                                  handleBgClick();
                                }}
                              >
                                <EditSharpIcon className="material-symbols-sharp" />
                              </label>
                            </>
                          )} 
                        </div> 

                      <input
                        type="file"
                        ref={fileInputRefBg}
                        style={{ display: "none" }}
                        onChange={handleBgImageChange}
                        accept="image/*"
                      />
                    </div>
 
                      <div
                        className={`profileImg new-profileImg ${userData?.openInfo?.type === "ToWork"
                          ? "animateToWork"
                          : userData?.openInfo?.type === "ToHire"
                            ? "animateToHire"
                            : userData?.openInfo?.type === "Freelance"
                              ? "animateFreelance"
                              : ""
                          }`}
                        onClick={() => setOpenProfileModal(true)}
                      >
                        <img
                          src={profilePicSrc}
                          alt=""
                          onError={handleProfileImageError}
                        />
                        {userUid === uid && (
                          <label
                            htmlFor="fileInput"
                            className="background-edit"
                            onClick={(event) => {
                              event.stopPropagation();
                              handleProfileClick();
                            }}
                          >
                            <EditSharpIcon className="material-symbols-sharp" />
                          </label>
                        )}
                      </div> 

                    <input
                      type="file"
                      ref={fileInputRefProfile}
                      style={{ display: "none" }}
                      onChange={handleProfileImageChange}
                      accept="image/*"
                    />

                    <div
                      className="profileDetails new-profileDetails pointer"
                      onClick={(event) => setOpenBgModal(true)}
                    >
                      <h4 onClick={(e) => e.stopPropagation()}>
                        {userData?.profileInfo?.firstName}{" "}
                        {userData?.profileInfo?.lastName}{" "}
                      </h4>
                      <div
                        className="d-flex align-items-center"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Link to="/">{userData?.profileInfo?.nameTag}</Link>{" "}
                        <div className=" badge-vip  ">{uid} </div>
                      </div>
                      <p onClick={(e) => e.stopPropagation()}>
                        {userData?.profileInfo?.headLine}
                      </p>
                      <p onClick={(e) => e.stopPropagation()}>
                        {userData?.profileInfo?.title}
                      </p>
                      <p onClick={(e) => e.stopPropagation()}>
                        {userData?.profileInfo?.cityName &&
                          `${userData?.profileInfo?.cityName},`}
                        {userData?.profileInfo?.countryName &&
                          ` ${userData?.profileInfo?.countryName}`}
                      </p>
                      {userData?.profileInfo?.isOwn === true ? (
                        ""
                      ) : (
                        <div
                          className="d-flex mt-1 ms-2"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="circle-container">
                            {shortMutualList?.pics?.map((pic, picIndex) => (
                              <img
                                src={pic}
                                alt={`Circle ${picIndex + 1}`}
                                //    className="circle-img"
                                key={picIndex}
                                onClick={() => setActiveTab(9)}
                                onError={handleProfileImageError}
                              />
                            ))}
                          </div>
                          {console.log("shortMutualList", shortMutualList)}

                          <div
                            className={`f-12 ${shortMutualList?.count === 1 ? "ms-0" : "ms-2"
                              }`}
                            onClick={() => setActiveTab(9)}
                          >
                            {shortMutualList?.text}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="profileHeader new-profileHeader">
                      <div className=" profileHead-content">
                        {guestModeData === "true" ? (
                          ""
                        ) : (                 
                          <div className="d-flex">
                            {uid === userUid ? (
                              userData?.openInfo?.type === "None" || userData?.openInfo?.type === null ? (
                                <button
                                 className={`${
                                    language === "en" ? "gradientBtn" : language === "ar" ? "gradientBtn1" : "gradientBtn2"
                                  } me-3 d-flex align-items-center justify-content-between`}
                                  // className="gradientBtn me-3 d-flex align-items-center"
                                  onClick={() => setOpenToModal(true)}
                                  
                                >
                                  <AddCircleSharpIcon className="material-symbols-sharp" />
                                  {t("User Profile.SetOpenAs")}
                                </button>
                              ) : (
                                "" // No fallback
                              )
                            ) : userData?.openInfo?.type === "ToHire" ? (
                              <button  className={`${
                                    language === "en" ? "gradientBtn" : language === "ar" ? "gradientBtn1" : "gradientBtn2"
                                  } me-3 ms-3`}
                              >#{t("User Profile.Hiring")}</button>
                            ) : userData?.openInfo?.type === "ToWork" ? (
                              <button  
                              className={`${
                                    language === "en" ? "gradientBtn" : language === "ar" ? "gradientBtn1" : "gradientBtn2"
                                  } me-3 ms-3`}
                                  >#{t("User Profile.OpenToWork")}</button>
                            ) : userData?.openInfo?.type === "Freelance" ? (
                              <button  className={`${
                                    language === "en" ? "gradientBtn" : language === "ar" ? "gradientBtn1" : "gradientBtn2"
                                  } me-3 ms-3`}>#{t("User Profile.Freelancing")}</button>
                            ) : (
                              "" // Public view does not show plus button for "None"
                            )}
                          </div>
                        )}

                        <div className="tabButton new-tabButton w-100 me-2">
                          <div
                            // onClick={() => setActiveTab(1)}
                            onClick={() => goToProfileTab(1)}
                            className={`text-center pointer aboutTab me-4 ${activeTab === 1 ? "activeTab" : ""
                              }`}
                          >
                            <p className="f-12 tabName">{t("User Profile.About")} </p>
                          </div>
                          <div
                            // onClick={() => setActiveTab(2)}
                            onClick={() => goToProfileTab(2)}
                            className={`text-center pointer  me-4 ${activeTab === 2 ? "activeTab" : ""
                              }`}
                          >
                            <p className="f-12 tabName">{t("User Profile.Post")} </p>
                            <p className="f-14 tabCount">{userStat?.postsCount}</p>
                          </div>
                          <div
                            // onClick={() => setActiveTab(3)}
                            onClick={() => goToProfileTab(3)}
                            className={`text-center pointer  me-4 ${activeTab === 3 ? "activeTab" : ""
                              }`}
                          >
                            <p className="f-12 tabName">{t("User Profile.Followers")}</p>
                            <p className="f-14 tabCount">
                              {userStat?.followersCount}
                            </p>
                          </div>
                          <div
                            // onClick={() => setActiveTab(4)}
                            onClick={() => goToProfileTab(4)}
                            className={`text-center pointer  me-4 ${activeTab === 4 ? "activeTab" : ""
                              }`}
                          >
                            <p className="f-12 tabName">{t("User Profile.Following")}</p>
                            <p className="f-14 tabCount">
                              {userStat?.followingCount}
                            </p>
                          </div>
                          {guestModeData === "true" ||
                            (userData?.profileInfo?.isOwn === false && (
                              <div
                                // onClick={() => setActiveTab(9)}
                                onClick={() => goToProfileTab(9)}
                                className={`text-center pointer  me-4 ${activeTab === 9 ? "activeTab" : ""
                                  }`}
                              >
                                <p className="f-12 tabName">{t("User Profile.Mutual Connections")}</p>
                                <p className="f-14 tabCount">
                                  {shortMutualList === null
                                    ? "0"
                                    : shortMutualList?.count}
                                </p>
                              </div>
                            ))}
                            {userData?.profileInfo?.isOwn === true && (
                            <div 
                              onClick={() => goToProfileTab(7)}
                              className={`text-center pointer  me-4 ${activeTab === 7 ? "activeTab" : ""
                                }`}
                            >
                              <p className="f-12 tabName">{t("User Profile.SavePost")}</p>
                              <p className="f-14 tabCount">
                                {userStat?.savedPostsCount}
                              </p>
                            </div>
                          )}
                          <div className="tabDropdownWrapper" style={{ display: 'inline-block', position: 'relative' }}>
                            <span
                              className="pointer"
                              onClick={() => setShowTabDropdown((prev) => !prev)}
                              style={{ display: 'inline-flex', alignItems: 'center', padding: '0 8px' }}
                            >
                              <MoreHorizSharpIcon className="material-symbols-sharp" />
                            </span>
                            {showTabDropdown && (
                              <Dropdown.Menu
                                show={showTabDropdown}
                                ref={tabDropdownRef}
                                className="InteractionModal"
                                style={{ minWidth: 180, right: 0, left: 'auto', position: 'absolute', zIndex: 1000 }}
                              >
                                {userData?.profileInfo?.isOwn === true && (
                                  <Dropdown.Item as="button" className="dropdownList" onClick={() => { goToProfileTab(8); setShowTabDropdown(false); }}>
                                    <span className="dropdownTxt f-14">{t("User Profile.HiddenPost")}</span>
                                  </Dropdown.Item>
                                )}
                                {userData?.profileInfo?.isOwn === true && (
                                  <Dropdown.Item
                                    as="button"
                                    className="dropdownList"
                                    onClick={() => {
                                      setShowTabDropdown(false);
                                      openModal();
                                    }}
                                  >
                                    <span className="dropdownTxt f-14">{t("User Profile.Post Analytics")}</span>
                                  </Dropdown.Item>
                                )}
                                {/* {userData?.profileInfo?.isOwn === true && (
                                  <Dropdown.Item as="button" className="dropdownList" onClick={() => { setActiveTab(11); window.location.hash = "Activities"; setShowTabDropdown(false); }}>
                                    <span className="dropdownTxt f-14">{t("User Profile.Activities")}</span>
                                  </Dropdown.Item>
                                )} */}
                                <Dropdown.Item as="button" className="dropdownList" onClick={() => { goToProfileTab(12); setShowTabDropdown(false); }}>
                                  <span className="dropdownTxt f-14">{t("User Profile.Media")}</span>
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* For Mobile view */}

                  <div className="card profileCard mobileView">
                    <div className="Profilebackground">
                      {/* <img src={Profile.Background} alt="" /> */}
                      <div
                        className="background-overlay"
                        onClick={(event) => setOpenBgModal(true)}
                      >
                        <img
                          src={bannerImageSrc}
                          alt=""
                          height={200}
                          onError={handleBannerImageError}
                        />
                        {userUid === uid && (
                          <>
                            <label
                              htmlFor="fileInput"
                              className="backgroundimg-edit"
                              onClick={(event) => {
                                event.stopPropagation();
                                handleBgClick();
                              }}
                            >
                              <EditSharpIcon className="material-symbols-sharp" />
                            </label>
                          </>
                        )}
                      </div>
                    </div>

                    <div
                      className={`profileImg ${userData?.openInfo?.type === "ToWork"
                        ? "animateToWork"
                        : userData?.openInfo?.type === "ToHire"
                          ? "animateToHire"
                          : userData?.openInfo?.type === "Freelance"
                            ? "animateFreelance"
                            : ""
                        }`}
                      onClick={() => setOpenProfileModal(true)}
                    >
                      <img
                        src={profilePicSrc}
                        alt=""
                        onError={handleProfileImageError}
                      />
                      {userUid === uid && (
                        <label
                          htmlFor="fileInput"
                          className="background-edit"
                          onClick={(event) => {
                            event.stopPropagation();
                            handleProfileClick();
                          }}
                        >
                          <EditSharpIcon className="material-symbols-sharp" />
                        </label>
                      )}
                    </div>
                    <input
                      type="file"
                      ref={fileInputRefProfile}
                      style={{ display: "none" }}
                      onChange={handleProfileImageChange}
                      accept="image/*"
                    />

                    <div className="profileDetails-mb pt-4  p-2 text-center">
                      <h4>
                        {userData?.profileInfo?.firstName}{" "}
                        {userData?.profileInfo?.lastName}{" "}
                      </h4>
                      <div className="d-flex align-items-center justify-content-center">
                        <Link to="/">{userData?.profileInfo?.nameTag}</Link>{" "}
                        <div className="badge-vip">{uid}</div>
                      </div>
                      <p>{userData?.profileInfo?.headLine}</p>
                      <p>{userData?.profileInfo?.title}</p>
                      <p>
                        {userData?.profileInfo?.cityName &&
                          `${userData?.profileInfo?.cityName},`}
                        {userData?.profileInfo?.countryName &&
                          ` ${userData?.profileInfo?.countryName}`}
                      </p>
                      <div className="d-flex mt-1 ms-2 AllFollower-container">
                        <div className="circle-container">
                          {shortMutualList?.pics?.map((pic, picIndex) => (
                            <img
                              src={pic}
                              alt={`Circle ${picIndex + 1}`}
                              className="circle-img"
                              key={picIndex}
                              onError={handleProfileImageError}
                            />
                          ))}
                        </div>
                        {/* <div className="f-12" >{shortMutualList?.text}</div> */}
                        <div
                          className={`f-12 ${shortMutualList?.count === 1 ? "ms-0" : "ms-1"
                            }`}
                          onClick={() => setActiveTab(9)}
                        >
                          {shortMutualList?.text}
                        </div>
                      </div>
                    </div>

                    <div className="profileHeader d-flex align-items-center flex-column flex-md-row">
                      {guestModeData === "true" ? (
                        ""
                      ) : (
                        <div className="d-flex">
                          {/* {uid === userUid ? (
                            userData?.openInfo?.type === "ToHire" ? (
                              <button
                                className="gradientBtn me-3 ms-3"
                                onClick={() => {
                                  setOpenToModal(true);
                                }}
                              >
                                #Hiring
                              </button>
                            ) : userData?.openInfo?.type === "ToWork" ? (
                              <button
                                className="gradientBtn me-3 ms-3"
                                onClick={() => {
                                  setOpenToModal(true);
                                }}
                              >
                                #OpenToWork
                              </button>
                            ) : (
                              <button
                                className="gradientBtn me-3 d-flex align-items-center"
                                onClick={() => {
                                  setOpenToModal(true);
                                }}
                              >
                                <AddCircleSharpIcon className="material-symbols-sharp" />
                                OpenToWork
                              </button>
                            )
                          ) : userData?.openInfo?.type === "ToHire" ? (
                            <button className="gradientBtn me-3 ms-3">
                              #Hiring
                            </button>
                          ) : userData?.openInfo?.type === "ToWork" ? (
                            <button className="gradientBtn me-3 ms-3">
                              #OpenToWork
                            </button>
                          ) : (
                            ""
                          )} */}
                          {uid === userUid ? (
                            userData?.openInfo?.type === "ToHire" ? (
                              <button className="gradientBtn me-3 ms-3" onClick={() => setOpenToModal(true)}>
                                #{t("User Profile.Hiring")}
                              </button>
                            ) : userData?.openInfo?.type === "ToWork" ? (
                              <button className="gradientBtn me-3 ms-3" onClick={() => setOpenToModal(true)}>
                                #{t("User Profile.OpenToWork")}
                              </button>
                            ) : userData?.openInfo?.type === "Not Specified" ? (
                              <button className="gradientBtn me-3 d-flex align-items-center" onClick={() => setOpenToModal(true)}>
                                <AddCircleSharpIcon className="material-symbols-sharp" />
                                {t("User Profile.OpenToWork")}
                              </button>
                            ) : (
                              <button className="gradientBtn me-3 d-flex align-items-center" onClick={() => setOpenToModal(true)}>
                                <AddCircleSharpIcon className="material-symbols-sharp" />
                                {t("User Profile.OpenToWork")}
                              </button>
                            )
                          ) : userData?.openInfo?.type === "ToHire" ? (
                            <button className="gradientBtn me-3 ms-3">#{t("User Profile.Hiring")}</button>
                          ) : userData?.openInfo?.type === "ToWork" ? (
                            <button className="gradientBtn me-3 ms-3">#{t("User Profile.OpenToWork")}</button>
                          ) : userData?.openInfo?.type === "Not Specified" ? (
                            <button className="gradientBtn me-3 d-flex align-items-center">
                              <AddCircleSharpIcon className="material-symbols-sharp" />
                              {/* OpenToWork */}
                              {t("User Profile.OpenToWork")}
                            </button>
                          ) : (
                            ""
                          )}


                        </div>
                      )}

                      <div className="tabButton d-flex w-100">
                        <NavLink
                          // onClick={() => setActiveTab(1)}
                          onClick={() => goToProfileTab(1)}
                          className={`text-center aboutTab me-4 ${activeTab === 1 ? "activeTab" : ""
                            }`}
                        >
                          <p className="f-12 tabName">About</p>
                        </NavLink>
                        <NavLink
                          // onClick={() => setActiveTab(2)}
                          onClick={() => goToProfileTab(2)}
                          className={`text-center  me-4 ${activeTab === 2 ? "activeTab" : ""
                            }`}
                        >
                          <p className="f-12 tabName">Post</p>
                          <p className="f-14 tabCount">{userStat?.postsCount}</p>
                        </NavLink>
                        <NavLink
                          // onClick={() => setActiveTab(3)}
                          onClick={() => goToProfileTab(3)}
                          className={`text-center  me-4 ${activeTab === 3 ? "activeTab" : ""
                            }`}
                        >
                          <p className="f-12 tabName">Followers</p>
                          <p className="f-14 tabCount">
                            {userStat?.followersCount}
                          </p>
                        </NavLink>
                        <NavLink
                          // onClick={() => setActiveTab(4)}
                          onClick={() => goToProfileTab(4)}
                          className={`text-center  me-4 ${activeTab === 4 ? "activeTab" : ""
                            }`}
                        >
                          <p className="f-12 tabName">Following</p>
                          <p className="f-14 tabCount">
                            {userStat?.followingCount}
                          </p>
                        </NavLink>

                        {console.log("shortMutualList", shortMutualList)}

                        {guestModeData === "true" ||
                          (userData?.profileInfo?.isOwn === false && (
                            <NavLink
                              // onClick={() => setActiveTab(9)}
                              onClick={() => goToProfileTab(9)}
                              className={`text-center  me-4 ${activeTab === 9 ? "activeTab" : ""
                                }`}
                            >
                              <p className="f-12 tabName">Mutual Connections</p>
                              <p className="f-14 tabCount">
                                {shortMutualList === null
                                  ? "0"
                                  : shortMutualList?.count}
                              </p>
                            </NavLink>
                          ))}
                        {userData?.profileInfo?.isOwn === true && (
                          <NavLink
                            onClick={() => goToProfileTab(7)}
                            className={`text-center  me-4 ${activeTab === 7 ? "activeTab" : ""
                              }`}
                          >
                            <p className="f-12 tabName">Saved</p>
                            <p className="f-14 tabCount">
                              {userStat?.savedPostsCount}
                            </p>
                          </NavLink>
                        )}
                        {/* {userData?.profileInfo?.isOwn === true && (
                          <NavLink
                            // onClick={() => setActiveTab(11)}
                            onClick={() => goToProfileTab(11)}
                            className={`text-center  me-4 ${activeTab === 11 ? "activeTab" : ""
                              }`}
                          >
                            <p className="f-12 tabName">Activities</p>
                            <p className="f-14 tabCount">
                              {userStat?.savedPostsCount}
                            </p>
                          </NavLink>
                        )} */}
                        <NavLink
                          // onClick={() => setActiveTab(12)}
                          onClick={() => goToProfileTab(12)}
                          className={`text-center  me-4 ${activeTab === 12 ? "activeTab" : ""
                            }`}
                        >
                          <p className="f-12 tabName">Media</p>
                          <p className="f-14 tabCount">
                            {userStat?.savedPostsCount}
                          </p>
                        </NavLink>
                      </div>
                    </div>
                  </div>
            </div>   

            <div className="row mt-3 mainProfileContainer new-mainProfileContainer">
              <div className="col-lg-8 col-md-12 profileTabContent">
                
                <div>{renderTabContent()}</div> 
              </div>
              <div className="col-md-4 newsfeedPosts new-newsfeedPosts">
                <div className="ad-container">
                  <div className="AdwrapperwithText">
                    <div
                      className={`ad-wrapper`}
                      style={{
                        width: "100%",
                        height: "300px",
                        // overflow: "hidden",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <GoogleAdUnit
                        adSlot="9135916775"
                        style={{
                          display: "block",
                          width: "100%",
                          height: "100%",
                          margin: "0 auto",
                        }}
                      />
                    </div>
                    <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
                  </div>
                </div>
              </div>
            </div>
            </>
          
      )}

        {showModal && (
            <div
              className="modal fade show dashboard-modal"
              tabIndex="-1"
              role="dialog"
              style={{ display: "block" }}
            >
              <div
                className="modal-dialog modal-dialog-centered modal-lg"
                role="document"
              >
                <div className="modal-content">
                  <div className="setting-header d-flex justify-content-between align-items-center">
                    <div className="dashboard-modal-title">
                      <span className="dashboard-modal-title-icon">
                        <InsightsSharpIcon />
                      </span>
                      <h6>
                        {(userData?.profileInfo?.fullName ||
                          userData?.profileInfo?.name ||
                          "") +
                          " " +
                          t("User Profile.Dashboard")}
                      </h6>
                    </div>
                    <CloseSharpIcon
                      className="material-symbols-sharp me-2 pointer"
                      onClick={closeModal}
                    />
                  </div>
                  <div className="dashboard">
                    <div className="row g-3">
                      <div className="col-md-4">
                        <div className="dashboard-qr-panel">
                          <p className="dashboard-qr-label">
                            <QrCode2SharpIcon />
                            {t("User Profile.Your profile QR Code")}
                          </p>
                          <div className="qrImage dashboard-qr-frame">
                            <img src={Profile.qr} alt="" className="qrcode" />
                            <img src={Profile.logo} alt="" className="qrLogo" />
                          </div>
                          <div className="dashboard-side-stats">
                            <DashboardSideStat
                              icon={<VisibilitySharpIcon />}
                              label={t("User Profile.Profile views")}
                              value={ownerDash.profileViews}
                              loading={ownerDashLoading}
                            />
                            <DashboardSideStat
                              icon={<BarChartSharpIcon />}
                              label={t("User Profile.Post impressions")}
                              value={ownerDash.postImpressions}
                              loading={ownerDashLoading}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="dashboard-analytics">
                          <DashboardSection
                            tone="posts"
                            title={t("User Profile.Post Analytics")}
                            icon={<ArticleSharpIcon />}
                          >
                            <DashboardStatCard
                              tone="posts"
                              label={t("User Profile.All Posts by you")}
                              value={ownerDash.postsAll}
                              loading={ownerDashLoading}
                            />
                            <DashboardStatCard
                              tone="posts"
                              label={t("User Profile.This month by you")}
                              value={ownerDash.postsMonth}
                              loading={ownerDashLoading}
                            />
                          </DashboardSection>
                          <DashboardSection
                            tone="likes"
                            title={t("User Profile.Like Analytics")}
                            icon={<FavoriteSharpIcon />}
                          >
                            <DashboardStatCard
                              tone="likes"
                              label={t("User Profile.Liked posts by you")}
                              value={ownerDash.likedByYou}
                              loading={ownerDashLoading}
                            />
                            <DashboardStatCard
                              tone="likes"
                              label={t("User Profile.Liked posts to you")}
                              value={ownerDash.likedToYou}
                              loading={ownerDashLoading}
                            />
                          </DashboardSection>
                          <DashboardSection
                            tone="comments"
                            title={t("User Profile.Comment Analytics")}
                            icon={<ChatBubbleSharpIcon />}
                          >
                            <DashboardStatCard
                              tone="comments"
                              label={t("User Profile.Commented by you")}
                              value={ownerDash.commentedByYou}
                              loading={ownerDashLoading}
                            />
                            <DashboardStatCard
                              tone="comments"
                              label={t("User Profile.Commented to you")}
                              value={ownerDash.commentedToYou}
                              loading={ownerDashLoading}
                            />
                          </DashboardSection>
                          <DashboardSection
                            tone="shares"
                            title={t("User Profile.Share Analytics")}
                            icon={<ShareSharpIcon />}
                          >
                            <DashboardStatCard
                              tone="shares"
                              label={t("User Profile.Shared by you")}
                              value={ownerDash.sharedByYou}
                              loading={ownerDashLoading}
                            />
                            <DashboardStatCard
                              tone="shares"
                              label={t("User Profile.Shared your content")}
                              value={ownerDash.sharedToYou}
                              loading={ownerDashLoading}
                            />
                          </DashboardSection>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          {openBgModal && (
            <div
              className="modal fade show postAdd modal-lg"
              tabIndex="-1"
              role="dialog"
              style={{ display: "block" }}
              size="lg"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content d-flex justify-content-around p-2">
                  <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                    <h6>{t("modals.Background View")}</h6>
                    <CloseSharpIcon
                      className="material-symbols-sharp me-2 pointer"
                      onClick={() => handleOpenBgCloseModal()}
                    />
                  </div>
                  <div className="backrgound-profile-view d-flex justify-content-center">
                    <img
                      src={bannerImageSrc}
                      alt=""
                      onError={handleBannerImageError}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {openProfileModal && (
            <div
              className="modal fade show postAdd modal-sm"
              tabIndex="-1"
              role="dialog"
              style={{ display: "block" }}
              size="lg"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content d-flex justify-content-around p-2">
                  <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                    <h6>{t("modals.Profile View")} </h6>
                    <CloseSharpIcon
                      className="material-symbols-sharp me-2 pointer"
                      onClick={() => handleOpenProfileCloseModal()}
                    />
                  </div>
                  <div className="p-2">
                    <div className="backrgound-profile-view d-flex justify-content-center">
                      <img
                        src={profilePicSrc}
                        alt=""
                        onError={handleProfileImageError}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {openToModal && (
            <div
              className="modal fade show postAdd"
              tabIndex="-1"
              role="dialog"
              style={{ display: "block" }}
            >
              <div
                className="modal-dialog  modal-dialog-centered "
                role="document"
              >
                <div className="modal-content d-flex justify-content-around p-2">
                  <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                    <h6>{t("User Profile.Setopenas")}</h6>
                    <CloseSharpIcon
                      className="material-symbols-sharp me-2 pointer"
                      onClick={() => {
                        handleopenToModal();
                      }}
                    />
                  </div>

                  <div className="col-md-12 mt-2">
                    {/* <label htmlFor="about"><strong>Select Work Type</strong></label> */}

                    {/* <Select
                      value={options.filter((c) => c.label === optionsLabel)}
                      options={options}
                      onChange={(e) => {
                        setOptionsValue(e.value);
                        setOptionsLabel(e.label);
                      }}
                      // loadOptions={selectlanguage}
                      placeholder="Select Status"
                    /> */}
                    {workOption.map((option) => (
                      <div className="ms-3">
                        <label key={option.id} style={{ display: 'block', marginBottom: '6px' }}>
                          <input
                            type="radio"
                            name="workType"
                            className="mt-3"
                            value={option.id}
                            checked={selectedOption?.id === option.id}
                            // onChange={() => setSelectedOption(option.id)}
                            onChange={() => handleSelection(option)}
                          />
                          <span className="ms-2">{option.name}</span>
                        </label>
                      </div>
                    ))}
                  </div>

                  <div className="col-md-12 text-end mt-4">
                    <button type="button" className="mainBtn1" onClick={OpenTo}>
                      {t("User Profile.Submit")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {profileModal && (
            <div
              className="modal fade show postAdd"
              tabIndex="-1"
              role="dialog"
              style={{ display: "block" }}
            >
              <div
                className="modal-dialog  modal-dialog-centered "
                role="document"
              >
                <div className="modal-content d-flex justify-content-around p-2">
                  <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                    <h6>{t("modals.Profile Pic")}</h6>
                    <CloseSharpIcon
                      className="material-symbols-sharp me-2 pointer"
                      onClick={handleProfileModalClose}
                    />
                  </div>
                  <div className="d-flex"></div>
                  <div className="uploaded-imagebg mt-2">
                    {selectedProfileImage && (
                      <div className="preview-container text-center position-relative d-inline-block" style={{ width: "100%" }}>
                        {/* <button
                          type="button"
                          onClick={() => {
                            setSelectedProfileImage(null);
                            setProfileImage(null);
                            setProfileModal(false);
                          }}
                          style={{
                            position: "absolute",
                            top: "8px",
                            right: "8px",
                            backgroundColor: "rgba(0,0,0,0.6)",
                            border: "none",
                            color: "white",
                            fontSize: "20px",
                            fontWeight: "bold",
                            borderRadius: "50%",
                            width: "32px",
                            height: "32px",
                            lineHeight: "28px",
                            cursor: "pointer",
                          }}
                        >
                          ×
                        </button> 
                         <img
                          src={selectedProfileImage}
                          alt="Selected"
                          className="img-fluid mb-3 rounded"
                          style={{ width: "100%", maxHeight: "300px" }}
                        /> */}

                       <div className="crop-app">
                        <div className="bg-crop-wrapper" style={{ position: "relative", height: 300, width: "100%" }}>
                          <Cropper
                            image={selectedProfileImage}
                            crop={crop}
                            zoom={zoom}
                            style={{ height: 200, width: "100%" }}
                            rotation={rotation}
                            aspect={1 / 1}
                            onCropChange={setCrop}
                            onCropComplete={onProfileCropComplete}
                            onRotationChange={setRotation}
                            onZoomChange={setZoom}
                          />
                        </div>
                      </div>

                        <div className="pt-2 old-button-area d-flex justify-content-center gap-2">
                          <span
                            className="pointer"
                            style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                            onClick={() => {
                              setProfileModal(false);
                                // open cropper with original source (same behavior as background image edit)
                                setProfileCropImage(profileSourceImage || selectedProfileImage);
                                setProfileCroppedAreaPixels(null);
                                setCrop({ x: 0, y: 0 });
                                setZoom(1);
                                setRotation(0);
                                setShowProfileCropper(true);
                            }}
                          >
                            <EditSharpIcon className="material-symbols-sharp" />
                          </span>

                          <span
                            className="pointer"
                            style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                            onClick={() => {
                              deleteProfileSelection();
                            }}
                          >
                            <DeleteSharpIcon className="material-symbols-sharp" />
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-md-12 text-end mt-4">
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={ProfileImageUpload}
                      disabled={loading}
                    >
                      {/* Submit */}
                      {loading === true ? `${t("SignIn.Loading")}` : `${t("User Profile.Submit")}`}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showProfileCropper && (
            <div
              className="modal fade show postAdd "
              tabIndex="-1"
              role="dialog"
              style={{ display: "block" }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content d-flex justify-content-around p-2">
                  <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                    <h6>{t("modals.Profile Pic")}</h6>
                    <CloseSharpIcon
                      className="material-symbols-sharp me-2 pointer"
                      onClick={cancelProfileCropping}
                    />
                  </div>
                  <div className="cropperContianer">
                    {selectedProfileImage && (
                      <div className="crop-app">
                        <div className="bg-crop-wrapper" style={{ position: "relative", height: 400, width: "100%" }}>
                          <Cropper
                            image={profileCropImage || selectedProfileImage}
                            crop={crop}
                            zoom={zoom}
                            style={{ height: 200, width: "100%" }}
                            rotation={rotation}
                            aspect={1 / 1}
                            onCropChange={setCrop}
                            onCropComplete={onProfileCropComplete}
                            onRotationChange={setRotation}
                            onZoomChange={setZoom}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="text-end mt-2">
                    <button className="closebtn me-2" onClick={cancelProfileCropping}>
                      {t("Connections.Cancel")}
                    </button>
                    <button className="mainBtn1" onClick={saveProfileCroppedImage}>
                      {t("Newsfeed.Apply Crop")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showBgCropper && (
            <div
              className="modal fade show postAdd "
              tabIndex="-1"
              role="dialog"
              style={{ display: "block" }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content d-flex justify-content-around p-2">
                  <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                    <h6>{t("modals.Background Image")}</h6>
                    <CloseSharpIcon
                      className="material-symbols-sharp me-2 pointer"
                      onClick={cancelBgCropping}
                    />
                  </div>
                  <div className="cropperContianer">
                    {bgSelectedImage && (
                      <div className="crop-app">
                        <div className="bg-crop-wrapper" style={{ position: "relative", height: 400, width: "100%" }}>
                          <Cropper
                            image={bgCropImage || bgSelectedImage}
                            crop={crop}
                            zoom={zoom}
                            style={{ height: 150, width: "100%" }}
                            rotation={rotation}
                            aspect={16 / 5}
                            
                            // aspectRatio={16 / 9} 
                            onCropChange={setCrop}
                            onCropComplete={onBgCropComplete}
                            onRotationChange={setRotation}
                            onZoomChange={setZoom}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="text-end mt-2">
                    <button className="closebtn me-2" onClick={cancelBgCropping}>
                      {t("Connections.Cancel")}
                    </button>
                    <button className="mainBtn1" onClick={saveBgCroppedImage}>
                      {t("Newsfeed.Apply Crop")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {bgModal && (
            <div
              className="modal fade show postAdd"
              tabIndex="-1"
              role="dialog"
              style={{ display: "block" }}
            >
              <div
                className="modal-dialog  modal-dialog-centered "
                role="document"
              >
                <div className="modal-content d-flex justify-content-around p-2">
                  <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                    <h6>{t("modals.Background Image")}</h6>
                    <CloseSharpIcon
                      className="material-symbols-sharp me-2 pointer"
                      onClick={() => {
                        handleBgModal();
                      }}
                    />
                  </div>

                  <div className=" mt-2">
                    {bgSelectedImage && (
                      <div className="preview-container text-center position-relative d-inline-block" style={{ width: "100%" }}>
                        {/* <button
                          type="button"
                          onClick={() => {
                              setBgSelectedImage(null);
                            setBackgroundImage(null);
                            setBgModal(false);
                            try { sessionStorage.removeItem("tempBgImage"); } catch (e) {}
                          }}
                          style={{
                            position: "absolute",
                            top: "8px",
                            right: "8px",
                            backgroundColor: "rgba(0,0,0,0.6)",
                            border: "none",
                            color: "white",
                            fontSize: "20px",
                            fontWeight: "bold",
                            borderRadius: "50%",
                            width: "32px",
                            height: "32px",
                            lineHeight: "28px",
                            cursor: "pointer",
                          }}
                        >
                          ×
                        </button> */}

                        {/* <div
                          className="img-fluid mb-3 rounded overflow-hidden"
                          style={{ width: "100%", maxHeight: "300px" }}
                        >
                          <img
                            src={bgSelectedImage}
                            alt="Selected"
                            className="img-fluid rounded"
                            style={{ width: "100%", maxHeight: "300px", objectFit: "cover" }}
                          />
                        </div> */}
                         <div className="crop-app">
                        <div className="bg-crop-wrapper" style={{ position: "relative", height: 300, width: "100%" }}>
                          <Cropper
                            image={bgCropImage || bgSelectedImage}
                            crop={crop}
                            zoom={zoom}
                            style={{ height: 150, width: "100%" }}
                            rotation={rotation}
                            aspect={16 / 5}
                            
                            // aspectRatio={16 / 9} 
                            onCropChange={setCrop}
                            onCropComplete={onBgCropComplete}
                            onRotationChange={setRotation}
                            onZoomChange={setZoom}
                          />
                        </div>
                      </div>

                        

                        <div className="pt-2 old-button-area d-flex justify-content-center gap-2">
                          <span
                            className="pointer"
                            style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                            onClick={() => {
                              setBgModal(false);
                              setBgCropImage(bgSourceImage || bgSelectedImage);
                              setShowBgCropper(true);
                            }}
                          >
                            <EditSharpIcon className="material-symbols-sharp" />
                          </span>
                          <span
                            className="pointer"
                            style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                            onClick={() => {
                                setBgSelectedImage(null);
                              setBackgroundImage(null);
                              setBgSourceImage(null);
                              setBgCropImage(null);
                              setBgModal(false);
                              try { sessionStorage.removeItem("tempBgImage"); } catch (e) {}
                            }}
                          >
                            <DeleteSharpIcon className="material-symbols-sharp" />
                          </span>

                           

                          {/* uses the hidden file input defined above (fileInputRefBg) */}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="col-md-12 text-end mt-4">
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={BgImageUpload}
                      disabled={loading}
                    >
                      {loading === true ? `${t("SignIn.Loading")}` : `${t("User Profile.Submit")}`}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <SuccessToast
            show={showToast}
            message={toastMessage}
            onClose={() => setShowToast(false)}
          />

          <WarningToast
            show={showWarningToast}
            message={warningToastMessage}
            onClose={() => setShowWarningToast(false)}
          />

          <ErrorToast
            show={showErrorToast}
            message={ErrorToastMessage}
            onClose={() => setShowErrorToast(false)}
          />

          {!isMobileViewport && (
            <div
              className={`fixed_Scrollbar-UserDetail-Toolbar ${showToolbar ? "show" : "hide"}`}
            >
              <div className="fixed_Scrollbar-UserDetail-ToolbarInner">
                <div className="fixed_Scrollbar-UserDetail-Toolbar_Details">
                  <div className="fixed_Scrollbar-UserDetail-Toolbar_UserIconBothfixed_Scrollbar-UserDetail-Toolbar_User_Details">
                    <div className="fixed_Scrollbar-UserDetail-Toolbar_UserIcon">
                      <div
                        className={`profileImg fixed_Scroll  ${userData?.openInfo?.type === "ToWork"
                            ? "animateToWork"
                            : userData?.openInfo?.type === "ToHire"
                              ? "animateToHire"
                              : userData?.openInfo?.type === "Freelance"
                                ? "animateFreelance"
                                : ""
                          }`}
                      >
                        <img
                          src={profilePicSrc}
                          alt=""
                          onError={handleProfileImageError}
                        />
                      </div>
                    </div>
                    <div className="fixed_Scrollbar-UserDetail-Toolbar_User_Details">
                      <h4>
                        {userData?.profileInfo?.firstName}{" "}
                        {userData?.profileInfo?.lastName}
                      </h4>
                      <div className="fixed_Scrollbar-UserDetail-Toolbar_User_Details_Resume">
                        <Link to="/">{userData?.profileInfo?.nameTag}</Link>
                      </div>
                    </div>
                  </div>
                  {!userData?.profileInfo?.isOwn && !isBlockedByYou ? (
                    <div className="fixed_Scrollbar-UserDetail-Toolbar_Buttons">
                      <Connection
                        uid={uid}
                        connectionCheck={connectionCheck}
                        setConnectionCheck={setConnectionCheck}
                        connectionId={connectionId}
                        CheckConnectUser={CheckConnectUser}
                        userData={userData}
                        setDisconectCheck={setDisconectCheck}
                        disconectCheck={disconectCheck}
                      />
                      {userData?.profileInfo?.isConnectedByYou === true ? (
                        ""
                      ) : userData?.profileInfo?.isFollowedByYou === true ||
                        isfollowed === true ? (
                        ""
                      ) : (
                        <div className="unFollowBtn ms-3">
                          <button
                            type="button"
                            className="wljPrimaryBtn wlj-chip-btn"
                            onClick={guestModeData === "true"
                              ? () => setJobModal(true)
                              : () => FollowedUser()}
                          >
                            <PersonAddAlt1SharpIcon />
                            {t("Companies.Follow")}
                          </button>
                        </div>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          )}

                {jobModal && <ModalForGuest closeModalData={closeModalData} />}
    </>

  );
};

export default PersonalProfile;
